import { createFileRoute } from '@tanstack/react-router';
import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FileUpload } from '@/components/shared/file-upload';
import type { UploadedFile } from '@/types/file-upload';
import { FileUploadMode, UploadMode } from '@/types/file-upload';

export const Route = createFileRoute('/__authenticated/dashboard/')({
	staticData: { titleKey: 'navigation.dashboard' },
	component: RouteComponent,
});

function RouteComponent(): ReactElement {
	const { t } = useTranslation();
	const [uploadedFiles, setUploadedFiles] = useState<UploadedFile[]>([]);

	async function handleUpload(file: File) {
		await new Promise((resolve) => setTimeout(resolve, 1500));

		const mockUploadedFile: UploadedFile = {
			id: `${Date.now()}-${Math.random()}`,
			name: file.name,
			size: file.size,
			type: file.type,
			url: URL.createObjectURL(file),
			uploadedAt: new Date(),
		};

		return {
			success: true,
			file: mockUploadedFile,
		};
	}

	async function handleDelete(fileId: string) {
		await new Promise((resolve) => setTimeout(resolve, 500));
		console.log('Deleting file:', fileId);
	}

	return (
		<div className="flex flex-col gap-8 p-4">
			<div>
				<h1 className="font-mono text-3xl font-medium">{t('dashboard.title')}</h1>
				<p className="text-sm font-normal text-muted-foreground">{t('dashboard.subtitle')}</p>
			</div>

			<div className="flex flex-col gap-6">
				<div className="flex flex-col gap-3">
					<h2 className="text-lg font-semibold">{t('dashboard.fileUpload.simpleModeTitle')}</h2>
					<div className="flex items-center gap-3">
						<p>{t('dashboard.fileUpload.testFileUpload')}</p>
						<FileUpload
							mode={FileUploadMode.Simple}
							multiple={false}
							uploadMode={UploadMode.Immediate}
							onUpload={handleUpload}
							onDelete={handleDelete}
							value={uploadedFiles}
							onChange={(files) => setUploadedFiles(files as UploadedFile[])}
						/>
					</div>
				</div>

				<div className="flex flex-col gap-3">
					<h2 className="text-lg font-semibold">{t('dashboard.fileUpload.dropzoneStagedTitle')}</h2>
					<FileUpload
						mode={FileUploadMode.Dropzone}
						multiple={true}
						uploadMode={UploadMode.Staged}
						onChange={(files) => console.log('Staged files:', files)}
					/>
				</div>

				<div className="flex flex-col gap-3">
					<h2 className="text-lg font-semibold">{t('dashboard.fileUpload.dropzoneImmediateTitle')}</h2>
					<FileUpload
						mode={FileUploadMode.Dropzone}
						multiple={true}
						uploadMode={UploadMode.Immediate}
						onUpload={handleUpload}
						onDelete={handleDelete}
					/>
				</div>
			</div>
		</div>
	);
}
